export const ACTIVE_HOME_TAB            = "ACTIVE_HOME_TAB";
export const ACTIVE_DEPARTMENT_TAB      = "ACTIVE_DEPARTMENT_TAB";
export const ACTIVE_DOCTOR_TAB          = "ACTIVE_DOCTOR_TAB";
export const ACTIVE_SCHEDULE_SUCCESSFUL_TAB          = "ACTIVE_SCHEDULE_SUCCESSFUL_TAB";
export const ACTIVE_SERVICE_PRICE_TAB   = "ACTIVE_SERVICE_PRICE_TAB";
export const ACTIVE_MEDICINE_TAB        = "ACTIVE_MEDICINE_TAB";
export const ACTIVE_ENTERPRISE_TAB      = "ACTIVE_ENTERPRISE_TAB";
export const ACTIVE_VIEW_SCHEDULE_TAB   = "ACTIVE_VIEW_SCHEDULE_TAB";
export const ACTIVE_PATIENT_RESULT_TAB  = "ACTIVE_PATIENT_RESULT_TAB";
export const ACTIVE_DISPLAY_PATIENT_RESULT_TAB  = "ACTIVE_DISPLAY_PATIENT_RESULT_TAB";
export const ACTIVE_SETTING_TAB         = "ACTIVE_SETTING_TAB";
export const ACTIVE_SETTING_NORMAL_TAB  = "ACTIVE_SETTING_NORMAL_TAB";
export const ACTIVE_SETTING_PATIENT_TAB = "ACTIVE_SETTING_PATIENT_TAB";
export const ACTIVE_SETTING_SYSTEM_TAB  = "ACTIVE_SETTING_SYSTEM_TAB";

export const LOADING = "LOADING";
export const FAILURE = "FAILURE";
export const SUCCESS = 'SUCCESS';